import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import _ from 'lodash';
import Moment from 'moment';
import { redirectToRoute } from '../../actions/common.actions';
import NotificationListItems from './NotificationListItems';
import DateDivider from '../appointments/DateDivider';
import { HEADER } from '_constants';
import { headerActions, notificationActions, bottomnavActions, referralActions } from 'actions';
import { bindActionCreators } from 'redux';
import { ErrorMessage } from '../common';
import { ERROR_MESSAGE_SCREEN, NOTIFICATIONS } from '../../constants';
import ContentLoader from '../common/loaders/ContentLoader';
import { showServerResponse } from '../../actions/modals.actions';
import NoNotificationsIcon from 'assets/images/NoNotificationsIcon.svg';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'Notifications',
  hasBackButton: true,
  hasNotificationIcon: true,
  showFooterWithBackButton: true
};

const todayDate = Moment().format('YYYY/MM/DD');
const moment = Moment;

class Notifications extends React.Component {
  static propTypes = {
    notifications: PropTypes.array,
    setHeader: PropTypes.func.isRequired,
    getNotification: PropTypes.func.isRequired,
    redirectTo: PropTypes.func.isRequired,
    markNotificationAsRead: PropTypes.func.isRequired,
    getNotificationCount: PropTypes.func.isRequired,
    changeActiveItem: PropTypes.func.isRequired,
    showServerResponse: PropTypes.func.isRequired,
    getRefferrals: PropTypes.func.isRequired,
    setActiveReferral: PropTypes.func.isRequired,
    fetchReferrals: PropTypes.func.isRequired,
    referrals: PropTypes.object.isRequired,
    setActiveOpportunity: PropTypes.func.isRequired
  }

   _isMounted = false;

  componentDidMount = async () => {
    this._isMounted = true;
    this.props.setHeader(headerSettings);
    this.props.changeActiveItem('Notifications');
    this.props.getNotification();
    this.props.getNotificationCount();
    this.props.getRefferrals();
    this.props.fetchReferrals();
  }

  navigateToPage = async (value) => {
    if ((!value) || (typeof value.actionType === 'undefined') || (value.actionType == null)) { return; }
    const referral = _.find(this.props.referrals.allReferrals, { contactKey: value.contactId });
    const opportunity = _.find(_.get(referral, 'opportunities', {}), { opportunityKey: value.objectId });

    let response = '';
    let additionalData = '';

    if (value.additionalData && (value.actionType === NOTIFICATIONS.ACTION_TYPE.ACCEPT_LEAD)) {
      value.actionType = NOTIFICATIONS.ACTION_TYPE.ACCEPT_LEAD_DIRECT_ROUTE;
    }

    switch (value.actionType.toString()) {
      case NOTIFICATIONS.ACTION_TYPE.DISPLAY_ONLY:
        this.props.markNotificationAsRead(value.id);
        break;
      case NOTIFICATIONS.ACTION_TYPE.CONFIRM_APPOINTMENT: case NOTIFICATIONS.ACTION_TYPE.MADE_CONTACT:
        this.props.setActiveReferral(referral);
        this.props.redirectTo(`/referraldetails/${value.contactId}/appointment/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.ACCEPT_LEAD:
        this.props.redirectTo(`/referraldetails/${value.contactId}/appointment/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.AUTOASSIGN_LEADACCEPTANCE:
        additionalData = JSON.parse(value.additionalData);
        this.props.redirectTo(`/autoacceptlead/${value.contactId}/opportunity/${additionalData.OpportunityId}/appointment/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.ACCEPT_LEAD_DIRECT_ROUTE:
        this.props.setActiveReferral(referral);
        this.props.redirectTo(`/leadacceptance/${value.contactId}/opportunity/${value.OpportunityId}/appointment/${value.additionalData.calendarEventId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.APPOINTMENT_REMINDER:
        this.props.markNotificationAsRead(value.id, value.contactId);
        this.props.redirectTo(`/appointmentdetails/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.APPOINTMENT_OUTCOME:
        this.props.redirectTo(`/appointmentdetails/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.WEEKLY_STATUS_UPDATE:
        await this.props.setActiveOpportunity(opportunity);
        this.props.markNotificationAsRead(value.id, value.contactId);
        this.props.redirectTo(`/statusupdates/${value.contactId}/${value.objectId}`);
        break;
      case NOTIFICATIONS.ACTION_TYPE.OPPORTUNITY_CLOSED:
        response = await this.props.markNotificationAsRead(value.id, value.contactId, true);
        this.props.showServerResponse(response, 'Opportunity Closed', 'Error');
        break;
      case NOTIFICATIONS.ACTION_TYPE.NEW_TASK:
        this.props.redirectTo(`/taskdetails/${value.objectId}`);
        await this.props.markNotificationAsRead(value.id);
        break;
      case NOTIFICATIONS.ACTION_TYPE.COMPLETE_TASK:
        this.props.redirectTo(`/taskdetails/${value.objectId}`);
        break;
      default:
        break;
    }
  }

  checkIsToday = (date) => {
    if (!date) { return false; }
    const appointmentDate = date ? moment(date).format('YYYY/MM/DD') : '';
    return (appointmentDate === todayDate);
  };

  render () {
    const { notifications = [] } = this.props;
    let currentDate = '';
    function showDate (value) {
      const notificationDate = moment(value.modifiedDate).format('dddd, MMMM D');
      if (currentDate !== notificationDate) {
        currentDate = notificationDate;
        return true;
      }
      return false;
    }

    return (
      <React.Fragment>
        <section className='page-content notifications-page'>
          <div className='notifications-list-container'>
            {
              !notifications ? <ContentLoader isLoading />
                : (notifications || []).length === 0 ? <ErrorMessage errorMessage={ERROR_MESSAGE_SCREEN.NO_NOTIFICATIONS} errorImage={NoNotificationsIcon} />
                  : (notifications || []).sort((a, b) => (moment(b.modifiedDate) - moment(a.modifiedDate)))
                    .map((value, index) => {
                      return <div key={index} className='notifications-container'>
                        {showDate(value) ? <DateDivider date={value.modifiedDate} /> : ''}
                        <NotificationListItems
                          time={(value.actionType === 0) ? moment(value.modifiedDate).format('hh:mm A') : ''}
                          message={value.messageText}
                          actionType={value.actionType}
                          onClickHandler={this.navigateToPage}
                          notificationData={value}
                          id={value.id}
                        />
                      </div>;
                    })
            }
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { notifications, referrals } = state;
  return {
    referrals,
    notifications: get(notifications, 'notifications', null),
    allReferrals: _.get(referrals, 'allReferrals', {})
  };
};

const mapDispatchToProps = (dispatch) => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  getNotification: bindActionCreators(notificationActions.getNotification, dispatch),
  getRefferrals: bindActionCreators(referralActions.fetch, dispatch),
  setActiveReferral: bindActionCreators(referralActions.setActiveReferral, dispatch),
  markNotificationAsRead: bindActionCreators(notificationActions.markNotificationAsRead, dispatch),
  getNotificationCount: bindActionCreators(notificationActions.getNotificationCount, dispatch),
  redirectTo: bindActionCreators(redirectToRoute, dispatch),
  changeActiveItem: bindActionCreators(bottomnavActions.changeActiveItem, dispatch),
  showServerResponse: bindActionCreators(showServerResponse, dispatch),
  fetchReferrals: bindActionCreators(referralActions.fetch, dispatch),
  setActiveOpportunity: bindActionCreators(referralActions.setActiveOpportunity, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Notifications));
